import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BUSINESS_PARTNERS = `${config?.URL_BUSINESS_PARTNERS}`;

const request = async (method, endpoint, data = null, params = null) => {
  const url = `${BUSINESS_PARTNERS}${endpoint}`;
  try {
    const headers = await headers_get();
    return await axios({ method, url, data, headers });
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
    throw error;
  }
};


export const bussines_partnert_post = (data) => request("post", "/od/business-partners", data);
export const cashclosing_sectors_get = (route) => request("get", `/od/sectors?route=${route}`);
export const bussines_partnert_put = (data, id) => request("put", `/od/business-partners/${id}`, data);
export const bussines_partnert_put_qr = (data) => request("put", "/od/business-partners", data);
export const address_businesspartners_get = (id) => request("get", `/od/business-partners/${id}/address`);
export const data_businesspartners_get = (id) => request("get", `/od/business-partners/${id}`);
export const code_businesspartners_get = () => request("get", "/od/business-partners/code");
export const business_partner_delete = (id) => request("delete", `/od/business-partners/${id}`);
export const businesspartners_pointofsale_get = (data) => request("get", `/od/pointsofsale/business-partner?${data}`);

export const pointsale_cabinets_get = (id) => request("get", `/od/pointsofsale/${id}/cabinets`);

//Error en la estrutura de la resuesta
export const pointsale_sectors_get = (id) => request("get", `/od/pointsofsale/${id}/sectors`);

export const businesspartners_list_get = () => request("get", "/od/business-partners/basic-info");

export const pointsofsale_list_get = () => request("get", "/od/pointsofsale/basic-info");

export const products_lines_get = () => request("get", "/od/productslines");

export const post_array_pos_sector = (id, data) => request("post", `/od/sectors/${id}/pos/update-from-file`, data);
